import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { INFORMACOES_RECUPERAR_SENHA, RECUPERAR_SENHA, CODIGO_CENTRUS_RECUPERAR_SENHA } from '../../../app.constants';
import { RecuperarSenha } from '../../shared/dominios/recuperar-senha';
import { ResToken } from '../../shared/models/res-token.modul';
import { FuncoesCriptografia } from '../../shared/util/Funcoes-criptografia';
import { StorafeUtil } from '../../shared/util/storasge.util';
import { RecuperarSenhaService } from '../service/recuperar-senha.service';
import { LoginService } from './../../login/service/login.service';
import { MessageUtil } from '../../shared/messages/messageUtil';
import { throttle } from '../../shared/decorators/throttle';

@Component({
  selector: 'app-codigo-acesso',
  templateUrl: './codigo-acesso.component.html',
  styleUrls: ['./codigo-acesso.component.css']
})
export class CodigoAcessoComponent implements OnInit {

  @BlockUI() blockUi: NgBlockUI;

  formulario: FormGroup;

  key: string;


  codigo: string = null;

  resToken = new ResToken();

  tipoRP: any;
  recuperarSenha: RecuperarSenha = new RecuperarSenha();
  tipoContato: number;

  constructor(
    private router: Router,
    private loginService: LoginService,
    private recoverPasswordService: RecuperarSenhaService,
    private toastrService: ToastrService
  ) { }

  ngOnInit() {

    this.pegandoDadosSessionStorage();
    // this.getDadosRecuperarSenha();
  }

  pegandoDadosSessionStorage() {
    const recuperandoObjeto = StorafeUtil.recuperarSessionStorage(RECUPERAR_SENHA);

    if (recuperandoObjeto) {
      const paramentrosPesquisa = JSON.parse(recuperandoObjeto);
      this.recuperarSenha.dsEmail = paramentrosPesquisa['dsEmail'];
      this.recuperarSenha.nrFone = Number(paramentrosPesquisa['nrFone']);
      this.recuperarSenha.nrCpf = paramentrosPesquisa['nrCpf'];
      this.tipoContato = Number(paramentrosPesquisa['tipoContato']);
    } else {
      this.router.navigate(['/recuperarSenha/esqueceuSenha'], { skipLocationChange: true });
    }

  }


  getDadosRecuperarSenha() {
    const recuperandoObjeto = StorafeUtil.recuperarSessionStorage(INFORMACOES_RECUPERAR_SENHA);
    if (recuperandoObjeto) {
      const paramentrosPesquisa = JSON.parse(recuperandoObjeto);
      this.resToken.cdCentrus = paramentrosPesquisa['cdCentrus'];
      this.resToken.idTokenAcesso = paramentrosPesquisa['idTokenAcesso'];
      this.resToken.dsTokenAcesso = paramentrosPesquisa['dsTokenAcesso'];
      this.resToken.dhInclusao = paramentrosPesquisa['dhInclusao'];
      this.resToken.dsEmail = paramentrosPesquisa['dsEmail'];
      this.resToken.noFuncao = paramentrosPesquisa['noFuncao'];
    } {
      this.router.navigate(['/recuperarSenha/esqueceuSenha'], { skipLocationChange: true });
    }

  }


  // Função para permitir a edição da senha, passando o código de acesso enviado para o Email Usuário
  @throttle()
  async checkToken(codigo) {
    await this.loginService
    .loginGetToken()
      .then(async (token) => {
        await this.recoverPasswordService.checkToken(codigo, token)
          .then(
            (res) => {
              this.resToken.cdCentrus = res['cdCentrus'];
              this.resToken.idTokenAcesso = res['idTokenAcesso'];
              this.resToken.dsTokenAcesso = res['dsTokenAcesso'];
              this.resToken.dhInclusao = res['dhInclusao'];
              this.resToken.dsEmail = res['dsEmail'];
              this.resToken.noFuncao = res['noFuncao'];
              StorafeUtil.gravaSessionStorage(INFORMACOES_RECUPERAR_SENHA, this.resToken);
              StorafeUtil.gravaSessionStorage(CODIGO_CENTRUS_RECUPERAR_SENHA, this.resToken.cdCentrus);
              this.toastrService.success(MessageUtil.FASE_AVANCADA_SUCESSO);
              this.router.navigate(['/recuperarSenha/alterarSenha'], { skipLocationChange: true });
            },
            () => {
              this.toastrService.warning(MessageUtil.TOKEN_INVALIDO);
            }
          );
      })
      .catch(() => {
        this.blockUi.stop();
        this.toastrService.error(MessageUtil.TOKEN_FALHA);
      });
  }

  // ---------------------------------------------------------------------- ruan@centrus.org.br

  async sendAPI() {
    await this.loginService
    .loginGetToken()
      .then(async (token) => {
        this.recuperarSenha.dsTokenAcesso = FuncoesCriptografia.GenerateKey();
        await this.recoverPasswordService.saveToken(this.recuperarSenha, token);
        await this.recoverPasswordService.sendAPI(this.recuperarSenha, this.tipoContato)
          .then(() => this.toastrService.success(MessageUtil.TOKEN_ENVIADO))
          .catch(() => this.toastrService.error(MessageUtil.TOKEN_FALHA))
      })
      .catch(() => {
        this.blockUi.stop();
        this.toastrService.error(MessageUtil.ERROR_SENHA_LOGIN);
      });
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/recuperar-senha/codigo-acesso/codigo-acesso.component.ts